import { render, staticRenderFns } from "./footer-link-list.component.vue?vue&type=template&id=4c8fc244&"
import script from "./footer-link-list.component.vue?vue&type=script&lang=ts&"
export * from "./footer-link-list.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports